import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { TableGeneralAnalysis } from '../../common/table'
import {
  selectActivitiesRatiosAndRiskCellData,
  selectActivitiesRatiosAndRiskData,
  selectActivitiesRatiosAndRiskIds,
  selectActivitiesRatiosAndRiskRowGroup,
  selectLoading,
} from '../../store/slice'

const ActivitiesRatiosAndRisk = ({ isDynamicReport, settingDynamic = {} }) => {
  const loading = useSelector(selectLoading('activitiesRatiosAndRisk'))
  const loadingCompare = useSelector(
    selectLoading('activitiesRatiosAndRiskCompare'),
  )
  const ids = useSelector(selectActivitiesRatiosAndRiskIds)

  return (
    <div>
      <Element
        style={{
          fontSize: 14,
          fontWeight: 600,
          marginBottom: 8,
          marginTop: 36,
        }}
      >
        <Translate value="companyAnalysis.industryAnalysis.ACTIVITIES_RATIOS_RISK" />
      </Element>
      <div style={{ height: 250 }}>
        <TableGeneralAnalysis
          isDynamicReport={isDynamicReport}
          settingDynamic={settingDynamic}
          dataTable={{
            loading: loading || loadingCompare,
            ids,
            selectCellData: selectActivitiesRatiosAndRiskCellData,
            selectData: selectActivitiesRatiosAndRiskData,
            selectRowGroup: selectActivitiesRatiosAndRiskRowGroup,
          }}
        />
      </div>
    </div>
  )
}

export default ActivitiesRatiosAndRisk
